"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAsyncDefaultContext = exports.withDefaultContext = void 0;
exports.withDefaultContext = (interpreter, defaultContext) => {
    if (Object.keys(defaultContext).length === 0) {
        return interpreter;
    }
    const extend = (ctx) => Object.assign({}, defaultContext, ctx);
    return {
        featureFlag: (name, on, off, ctx) => interpreter.featureFlag(name, on, off, extend(ctx)),
        getBoolean: (name, ctx) => interpreter.getBoolean(name, extend(ctx)),
        getFloat: (name, ctx) => interpreter.getFloat(name, extend(ctx)),
        getInt: (name, ctx) => interpreter.getInt(name, extend(ctx)),
        getString: (name, ctx) => interpreter.getString(name, extend(ctx)),
        getJson: (name, ctx) => interpreter.getJson(name, extend(ctx)),
    };
};
exports.withAsyncDefaultContext = (interpreter, defaultContext) => {
    if (Object.keys(defaultContext).length === 0) {
        return interpreter;
    }
    const extend = (ctx) => Object.assign({}, defaultContext, ctx);
    return {
        featureFlag: (name, on, off, ctx) => interpreter.featureFlag(name, on, off, extend(ctx)),
        getBoolean: (name, ctx) => interpreter.getBoolean(name, extend(ctx)),
        getFloat: (name, ctx) => interpreter.getFloat(name, extend(ctx)),
        getInt: (name, ctx) => interpreter.getInt(name, extend(ctx)),
        getString: (name, ctx) => interpreter.getString(name, extend(ctx)),
        getJson: (name, ctx) => interpreter.getJson(name, extend(ctx)),
    };
};
//# sourceMappingURL=DefaultContext.js.map